import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
import { DOMAIN } from "./domain-constant";

// import { terminology } from "../helpers/terminology";
export default class ReceivalesProcessingService extends ApiService {
  namespace = "processing";
  DOMAIN = DOMAIN.RECEIVABLE_PROCESSING;
  name = "Associate";
  template = "defaultTemplate";
  Width = 900;
  icon = "Invoice";
  action = "action";
  // gems items on template menu items with custom icon
  // gemItems = [
  //   {
  //     key: "loader",
  //     label: "Estimates",
  //     icon: "Calculator",
  //     services: 40,
  //   },
  //   {
  //     key: "loader",
  //     label: "Work Orders",
  //     icon: "database",
  //     services: 171,
  //   },
  //   {
  //     key: "loader",
  //     label: "Invoices",
  //     icon: "Invoice",
  //     services: 35,
  //   },
  //   {
  //     key: "loader",
  //     label: "Payments",
  //     icon: "Dollar",
  //     services: 180,
  //   },
  //   {
  //     key: "loader",
  //     label: "Sales Receipt",
  //     icon: "Receipt",
  //     services: 117,
  //   },
  //   {
  //     key: "loader",
  //     label: "Credit Memos",
  //     icon: "Check",
  //     services: 56,
  //   },
  //   {
  //     key: "loader",
  //     label: "Deposits",
  //     icon: "BankBuilding",
  //     services: -41,
  //   },
  // ];
  gemItems = [
    {
      key: "loader",
      label: "Estimates",
      icon: "Plus",
      services: DOMAIN.ESTIMATE,
    },
    {
      key: "loader",
      label: "Work Orders",
      icon: "Briefcase",
      services: DOMAIN.WORK_ORDER,
    },
    {
      key: "loader",
      label: "Invoices",
      icon: "Document",
      services: DOMAIN.INVOICE,
    },
    {
      key: "loader",
      label: "Payments",
      icon: "Dollar",
      services: DOMAIN.FUND_RECEIVED,
    },
    {
      key: "loader",
      label: "Sales Receipt",
      icon: "Plus",
      services: DOMAIN.SALES_RECEIPTS,
    },
    {
      key: "loader",
      label: "Credit Memos",
      icon: "Bullets",
      services: DOMAIN.CREDIT_MEMO,
    },
    {
      key: "loader",
      label: "Deposits",
      icon: "Plus",
      services: DOMAIN.DEPOSIT,
    },
  ];

  constructor() {
    super("processing");
  }
}
